import axios from 'axios';

export default {
  fetchVersion() {
    return axios.get('/version');
  },

  authenticateUser(payload) {
    return axios.post('/auth', payload);
  },

  fetchUserInformation() {
    return axios.get('/user');
  },

  saveUserSettings(payload) {
    return axios.post('/user', payload);
  },

  saveUserAddress(payload) {
    return axios.post('/userAddress', payload);
  },

  saveUserPushToken(payload) {
    return axios.post('/user', { androidPushToken: payload });
  },

  updateUserDefaultAddress(payload) {
    return axios.put(`/userAddress/${payload.id}`, { default: payload.default });
  },

  updateUserAddress(payload) {
    return axios.put(`/userAddress/${payload.id}`, payload);
  },

  deleteUserAddress(payload) {
    return axios.delete(`/userAddress/${payload}`);
  },

  fetchCategoryById(id) {
    return axios.get(`/category/${id}`);
  },

  fetchCategories() {
    return axios.get('/category');
  },

  fetchProductById(productId) {
    return axios.get(`/product/${productId}`);
  },

  checkIfValidCouponCode({ coupon, deliveryMethodId }) {
    return axios.get(`/coupon/${coupon}/${deliveryMethodId}`);
  },

  fetchDeliveryMethod(payload) {
    return payload ? axios.get(`/deliveryMethod/${payload}`)
      : axios.get('/deliveryMethod');
  },

  // eslint-disable-next-line max-len
  createWoltShipmentPromise(deliveryMethodId, locationId, city, postCode, street, lat, lon, comment) {
    return axios.post(
      `/deliveryMethod/${deliveryMethodId}/${locationId}`,
      {
        lat, lon, city, postCode, street, comment,
      },
    );
  },

  fetchPaymentMethod(payload) {
    return payload ? axios.get(`/paymentMethod/${payload}`)
      : axios.get('/paymentMethod');
  },

  fetchLocations(payload) {
    return payload ? axios.get(`/location/${payload}`)
      : axios.get('/location');
  },

  fetchDeliveryMethods() {
    return axios.get('/deliveryMethod');
  },

  submitUsersOrder(payload) {
    return axios.post('/order', payload);
  },

  submitUsersPayment({
    orderUuid, paymentMethodId, paymentData, saveAsVirtual,
  }) {
    return axios.post('/payment', {
      orderUuid, paymentMethodId, paymentData, saveAsVirtual,
    });
  },

  setOrderStatusArrived(orderId) {
    return axios.put(`/order/${orderId}`, {
      status: 9,
    });
  },

  fetchLastOrderFromAPI() {
    return axios.get('/lastOrder');
  },

  fetchOrderFromAPI({ id }) {
    return axios.get(`/order/${id}`);
  },

  fetchAllOrdersFromAPI() {
    return axios.get('/orders');
  },

  fetchUserPaymentMethod() {
    return axios.get('/userPaymentMethod');
  },

  saveNewUserPaymentMethod(payload) {
    return axios.post('/userPaymentMethod', payload);
  },

  removeUserPaymentMethodById(payload) {
    return axios.delete(`/userPaymentMethod/${payload}`);
  },

  fetchUserItems() {
    return axios.get('/userFavorite');
  },

  saveUserItem(payload) {
    return axios.post('/userFavorite', payload);
  },

  removeUserItem(payload) {
    return axios.delete(`/userFavorite/${payload}`);
  },

  updateUserItem(payload) {
    return axios.put(`/userFavorite/${payload.id}`, { title: payload.title });
  },

  fetchUserByUuid({ uuid }) {
    return axios.get(`/user/${uuid}`);
  },

  fetchCustomerBySsn(payload) {
    return axios.get(`/customer/${payload}`);
  },
};
